import { useState } from "react";
import { RouterProvider } from "react-router";
import { QueryClientProvider } from "@pos/shared/query";
import { createQueryClient } from "@pos/shared/query";
import {
  setBaseUrl,
  setAuthBaseUrl,
  setConfigBaseUrl,
  setBillingBaseUrl,
  setTableOrderBaseUrl,
  setTableOrderConfigBaseUrl,
  setControlManagementBaseUrl,
  setReportsBaseUrl,
} from "@pos/shared/api";
import { setPingUrl } from "@pos/shared";
import { setRealtimeBaseUrl } from "@pos/shared/realtime";
import { router } from "@/routes";
import { useApplyTheme } from "@/lib/theme";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiV2Url = (import.meta.env.VITE_API_V2_URL as string) || apiUrl;
setBaseUrl(apiUrl);
setAuthBaseUrl(apiV2Url);
setConfigBaseUrl(apiV2Url);
setBillingBaseUrl(apiV2Url);
setTableOrderBaseUrl(apiV2Url);
setTableOrderConfigBaseUrl(apiV2Url);
setControlManagementBaseUrl(apiV2Url);
setReportsBaseUrl(apiV2Url);
setPingUrl(apiUrl);
setRealtimeBaseUrl(apiV2Url);

export function App() {
  const [queryClient] = useState(() => createQueryClient());
  useApplyTheme();

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
